import React, { useState } from "react";
import { log_error } from "../../../../api";
import { updateCurrentUser } from "../../../../api/users";
import { updateCurrentUserRedux } from "../../../../api/helper";
import "../styles.scss";
import { Link } from "react-router-dom";
import { getUserNameFromURL, getFormetedUrl, checkValidSocialMedia, checkAtSign } from "../../../../helper/helper";
import { isMobile } from "react-device-detect";

export default ({ user }) => {
  const { website, tiktok, instagram, spotify, twitter, facebook, itunes, youtube, soundcloud } = user.social_media_links || {};

  const instagramUsername = instagram?.toLowerCase().includes("instagram.com") ? getUserNameFromURL(instagram) : instagram;
  const twitterUsername =
    twitter?.toLowerCase().includes("twitter.com") || twitter?.toLowerCase().includes("x.com") ? getUserNameFromURL(twitter) : twitter;
  const facebookUsername = facebook?.toLowerCase().includes("facebook.com") ? getUserNameFromURL(facebook) : facebook;
  const socialMediaState = {
    ...user.social_media_links,
    tiktok: tiktok ? tiktok.split("@")[1] : "",
    instagram: instagramUsername,
    twitter: twitterUsername,
    facebook: facebookUsername,
  };
  const [state, setState] = useState(socialMediaState || {});
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  let [success, setSuccess] = useState(false);

  const updateForm = (e) => {
    const { name, value } = e.target;
    const isValidSocialMedia = checkValidSocialMedia(name);
    const isAtSign = checkAtSign(value);
    if (isValidSocialMedia && isAtSign) return;
    setState((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };
  const submitForm = async (e) => {
    e.preventDefault();
    try {
      setErrors(null);
      setSuccess("");
      setLoading(true);
      await updateCurrentUser({
        user: {
          social_media_links: {
            ...state,
            tiktok: state.tiktok ? "@" + state.tiktok : "",
            youtube: state.youtube ? getFormetedUrl(state.youtube) : "",
            spotify: state.spotify ? getFormetedUrl(state.spotify) : "",
            itunes: state.itunes ? getFormetedUrl(state.itunes) : "",
            soundcloud: state.soundcloud ? getFormetedUrl(state.soundcloud) : "",
          },
        },
      });
      updateCurrentUserRedux();
      setSuccess("Social Media profiles updated.");
    } catch (err) {
      setErrors(log_error(err));
    } finally {
      setLoading(false);
    }
  };

  const tiktokUsername = tiktok?.split("@")[1];
  return (
    <div id="social-media">
      {success && (
        <div className="alert alert-success">
          <small>{success}</small>
        </div>
      )}

      {errors && errors.length > 0 && (
        <div className="errors mt-2">
          {errors.map((e) => (
            <div className="alert alert-danger">{e.message}</div>
          ))}
        </div>
      )}
      <form onSubmit={submitForm} style={{ paddingTop: 20 }}>
        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">Website</label>
          </div>
          <div className="col-100 col-md-75">
            <input
              type="url"
              name="website"
              className="form-control"
              disabled={loading}
              pattern="https?://.*"
              placeholder="https://www.illuminate.com/"
              onChange={updateForm}
              defaultValue={website}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">Instagram</label>
          </div>
          <div className="col-100 col-md-75 position-relative">
            <span className="username">@</span>
            <input
              type="text"
              onChange={updateForm}
              name="instagram"
              className="form-control pl-3"
              pattern="[a-zA-Z0-9_-.]+"
              disabled={loading}
              placeholder="yourusername"
              defaultValue={instagram}
              value={state.instagram}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">TikTok</label>
          </div>
          <div className="col-100 col-md-75 position-relative">
            <span className="username">@</span>
            <input
              type="text"
              onChange={updateForm}
              name="tiktok"
              className="form-control pl-3"
              disabled={loading}
              pattern="[a-zA-Z0-9_.]+"
              placeholder="yourusername"
              defaultValue={tiktokUsername}
              value={state.tiktok}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">X</label>
          </div>
          <div className="col-100 col-md-75 position-relative">
            <span className="username">@</span>
            <input
              type="text"
              onChange={updateForm}
              name="twitter"
              className="form-control pl-3"
              disabled={loading}
              pattern="[a-zA-Z0-9_]+"
              placeholder="yourusername"
              defaultValue={twitter}
              value={state.twitter}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">Facebook</label>
          </div>
          <div className="col-100 col-md-75 position-relative">
            <span className="username">@</span>
            <input
              type="text"
              onChange={updateForm}
              name="facebook"
              className="form-control pl-3"
              disabled={loading}
              pattern="[a-zA-Z0-9.]+"
              placeholder="yourusername"
              defaultValue={facebook}
              value={state.facebook}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">Apple Music</label>
          </div>
          <div className="col-100 col-md-75">
            <input
              type="text"
              onChange={updateForm}
              name="itunes"
              className="form-control"
              disabled={loading}
              pattern="(http(s)?://)?(www.)?([pP][oO][dD][cC][aA][sS][tT][sS]|[mM][uU][sS][iI][cC]).[aA][pP][pP][lL][eE].[cC][oO][mM]/[uU][sS]/(podcast/.*|album/.*/[0-9]+|artist/.*/[0-9]+)"
              placeholder="https://music.apple.com/illuminate"
              defaultValue={itunes}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">Youtube</label>
          </div>
          <div className="col-100 col-md-75">
            <input
              type="text"
              onChange={updateForm}
              name="youtube"
              className="form-control"
              disabled={loading}
              pattern="(http(s)?://)?(www.)?[yY][oO][uU][tT][uU][bB][eE].[cC][oO][mM]/.*"
              placeholder="https://www.youtube.com/channel/illuminate"
              defaultValue={youtube}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">Soundcloud</label>
          </div>
          <div className="col-100 col-md-75">
            <input
              type="text"
              onChange={updateForm}
              name="soundcloud"
              className="form-control"
              disabled={loading}
              pattern="(http(s)?://)?(www.)?[sS][oO][uU][nN][dD][cC][lL][oO][uU][dD].[cC][oO][mM]/[a-zA-Z0-9_-]+"
              placeholder="https://soundcloud.com/illuminate"
              defaultValue={soundcloud}
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-100 col-md-25 d-flex align-items-center">
            <label className="m-0">Spotify</label>
          </div>
          <div className="col-100 col-md-75">
            <input
              type="text"
              onChange={updateForm}
              name="spotify"
              className="form-control"
              disabled={loading}
              pattern="(http(s)?://)?[oO][pP][eE][nN].[sS][pP][oO][tT][iI][fF][yY].[cC][oO][mM]/.*"
              placeholder="Share > Copy Profile Link on your Spotify Profile"
              defaultValue={spotify}
            />
          </div>
        </div>

        <div
          className="form-row d-flex justify-content-center mt-5"
          style={{ gap: 10, alignItems: "center", ...(isMobile ? { flexDirection: "column-reverse" } : {}) }}
        >
          <Link to="/">
            <button disabled={loading} type="reset" className="submit btn btn-outline-primary mx-3">
              Cancel
            </button>
          </Link>
          <button disabled={loading} type="submit" className="submit btn btn-primary mx-3">
            {loading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};
